import styled, { css } from 'styled-components';
import { down } from 'styled-breakpoints';
import { motion } from 'framer-motion';

export const Container = styled(motion.dialog)`
  ${({ theme }) => css`
    padding: 2.5rem 2rem;
    margin: auto;
    width: 100%;
    max-width: 45rem;
    height: 100%;
    max-height: 45rem;
    border-radius: 1rem;
    position: relative;
    background: ${theme.colors.background[100]};
    color: ${theme.colors.foreground[100]};
    box-shadow: 0px 2.8px 2.2px rgba(0, 0, 0, 0.02),
      0px 6.7px 5.3px rgba(0, 0, 0, 0.028), 0px 12.5px 10px rgba(0, 0, 0, 0.035),
      0px 22.3px 17.9px rgba(0, 0, 0, 0.042),
      0px 41.8px 33.4px rgba(0, 0, 0, 0.05), 0px 100px 80px rgba(0, 0, 0, 0.07);
    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 2px solid ${theme.colors.background[80]};
      > h2 {
        padding-bottom: 0.5rem;
      }
      > button {
        background: transparent;
        font-size: 1.5rem;
      }
    }
    ${down('md')} {
      padding: 2.5rem 1.25rem;
    }
  `}
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding-bottom: 4rem;

  .reactCrop {
    display: flex;
    justify-content: center;
    padding-top: 2rem;

    .ReactCrop .ReactCrop__crop-selection {
      border-radius: 50%;
    }

    img {
      width: 460px;
      height: 460px;
      object-fit: cover;
      object-position: center center;
    }
  }

  .btnsContent {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;
